<style scoped lang="scss">
  .wrap-tec{
    .container{
      width:1000px;
    }
    .context{
      p{
        text-indent: 2rem;
        line-height: 2;
        margin-bottom: 10px;
        &:last-child{
          margin-bottom: 0;
        }
      }
    }
    .required{
      background: #fff;
      padding:40px;
      margin-left: -40px;
      z-index: 2;
      p{
        line-height: 1.6;
      }
    }
  }
</style>
<style scoped>
@import url("../../assets/sanger.css");
</style>
<template>
  <div class="wrap wrap-tec">
    <div class="banner">
      <img src="@/assets/img/产品及服务/常规分子项目/banner7.jpg" class="img-fluid">
      <div class="info">
<!--        <div class="container">-->
<!--          <h1>16S rDNA菌种</h1>-->
<!--          <h2 class="mt10">16S rDNA Strain</h2>-->
<!--        </div>-->
      </div>
    </div>
    <div class="breads container" style="overflow:auto;line-height: 48px;padding-left: 10px;margin-top: 20px;">
      <bread></bread>
    </div>
    <section class="container">
      <div class="context" style="font-size: 16px;">
        <p>16S rDNA是编码原核生物核糖体小亚基rRNA(16S rRNA)的DNA序列，存在于所有细菌染色体基因组中。16S rDNA分子大小适中，突变率小，是细菌系统分类学研究中常用且有效的“分子钟”。其序列包含9个可变区（variable region）和10个恒定区（constant region）。保守序列区域反映了生物物种间的亲缘关系，而高变序列区域则能体现物种间的差异。16S rDNA的序列特征为不同分类级别的近缘种系统分类奠定了分子生物学基础。</p>
        <p>采用测序方法对各种细菌的16S rDNA进行了广泛的研究，获得了大量的16S rDNA序列信息，并汇集到NCBI数据库中。将测序得到的16S rDNA序列在NCBI上进行Blast比对，即可获知与该序列同源性较高的已知序列，为确定菌种的分类学地位提供依据。</p>
      </div>
      <div class="c-title">实验流程<small>Experiment Process</small></div>
      <div class="tc"><img src="@/assets/images/rdna_1.png"></div>
      <div class="c-title">送样要求<small>Sample Delivery Requirements</small></div>
      <el-row type="flex" align="bottom">
        <el-col :span="12">
          <img src="@/assets/images/rdna_2.png" class="img-fluid">
        </el-col>
        <el-col :span="12">
          <div class="required">
            <p>1、基因组DNA样品，请确保浓度 ≥ 10 ng/μL，总体积 ≥ 10μL，A260/A280比值为1.8左右；</p>
            <p>2、除基因组DNA样品外，仅接收培养过的菌液, 体积 ≥ 1 mL，请确保您提供的样品经过平板或斜面上的单菌落分离。因实验样品不纯造成的测序套峰，我们将收取全额的实验费用；</p>
            <p>3、若提供的菌株为革兰氏阳性菌，建议您提供基因组DNA；</p>
            <p>4、我们不接受具有致病性的样品。如果您的菌株带有致病性，请提供菌株的基因组DNA，并对其进行处理以灭活致病菌。</p>
          </div>
        </el-col>
      </el-row>
      <div class="c-title">我们可以提供的服务<small>Servise We Can Provide</small></div>
      <el-row type="flex" align="bottom">
        <el-col :span="12" style="z-index: 2">
          <div class="required" style="margin-right: -40px;margin-left: 0;">
            <p>1、细菌16S鉴定；</p>
            <p>2、真菌ITS区鉴定；</p>
            <p>3、多位点序列分型（MLST）；</p>
            <p>4、微生物其他保守基因检测。</p>
          </div>
        </el-col>
        <el-col :span="12">
          <img src="@/assets/images/rdna_3.jpg" class="img-fluid">
        </el-col>
      </el-row>
      <!-- <div class="c-title">服务价格<small>Service Pride</small></div>
      <table class="table">
        <tr>
          <th>项目内容</th>
          <th>样品类型</th>
          <th>价格</th>
        </tr>
        <tr>
          <td rowspan="2">细菌16S rDNA菌种鉴定</td>
          <td>基因组DNA</td>
          <td>200元/样本</td>
        </tr>
        <tr>
          <td>菌液</td>
          <td>300元/样本</td>
        </tr>
      </table> -->
      <div class="c-title">提供结果<small>Provide Results</small></div>
      <div class="tc">
        <p>1、测序峰图文件及序列文件；</p>
        <p>2、分析及对比情况。</p>
      </div>
      <div class="tc mt30"><img src="@/assets/images/rdna_4.png"></div>
    </section>
    <qk-consult type="Virus"/>
  </div>
</template>
<script>
import bread from "@/components/bread"
export default {
  components: {
    bread,
  },
  data () {
    return {

    }
  },
  methods: {

  }
}
</script>



// WEBPACK FOOTER //
// src/views/tec/rDNA.vue